import { render, staticRenderFns } from "./generalLessonForm.vue?vue&type=template&id=c00a6a4c&"
import script from "./generalLessonForm.vue?vue&type=script&lang=js&"
export * from "./generalLessonForm.vue?vue&type=script&lang=js&"
import style0 from "./generalLessonForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports